// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3ZhD3","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__16hac","gfeWrapper":"CalendarEvent_gfeWrapper__36OoJ"};